import { SnapshotCommentEditStep, TachoInfringementsEditStep } from 'pages/employee-reviews/completed/edit/steps';
import { tachoInfringementsTopicKey } from 'pages/employee-reviews/shared';
import { isSameText } from './employeeReviewEditHelpers';
import {
    applyLoadedTachoInfringements,
    createTachoInfringementsEditState,
    getTachoInfringementsEditGating,
    getTachoItemEdits,
    isTachoCommentChanged,
    isTachoInfringementsEditDirty
} from './tachoInfringementsEdit';

const defaultGating = { canProceed: true, cantProceedTooltip: null };

function isCommentChanged(state) {
    return !isSameText(state?.comment, state?.loadedComment);
}

// A topic whose record cannot be changed by an edit: its frozen record shown as the completed
// review shows it, and its comment. The comment as loaded is held beside the one being edited.
const snapshotCommentEditTopic = {
    Step: SnapshotCommentEditStep,
    createInitialState: () => ({ loadedComment: "", comment: "" }),
    applyLoaded: (topicEntry) => ({ loadedComment: topicEntry?.comment ?? "", comment: topicEntry?.comment ?? "" }),
    getGating: () => defaultGating,
    isDirty: isCommentChanged,
    getComment: (state) => state?.comment ?? "",
    isCommentChanged
};

// The Tacho Infringements topic, whose reviewed items can be corrected or returned to outstanding.
const tachoInfringementsEditTopic = {
    Step: TachoInfringementsEditStep,
    createInitialState: createTachoInfringementsEditState,
    applyLoaded: applyLoadedTachoInfringements,
    getGating: getTachoInfringementsEditGating,
    isDirty: isTachoInfringementsEditDirty,
    getComment: (state) => state?.comment ?? "",
    isCommentChanged: isTachoCommentChanged,
    getItemEdits: getTachoItemEdits
};

// The topic each edit step is built from, keyed by topic key. A topic with no entry here is edited
// as a frozen record and its comment.
const editTopicsByKey = {
    [tachoInfringementsTopicKey]: tachoInfringementsEditTopic
};

// One edit topic for each topic on the completed review, in the review's order, titled by the
// topic's own name.
export function getEditTopics(completedReview) {
    return (completedReview?.topics ?? []).map((topicEntry) => ({
        ...(editTopicsByKey[topicEntry.topicKey] ?? snapshotCommentEditTopic),
        key: topicEntry.topicKey,
        stepTitle: topicEntry.topicName,
        topicEntry
    }));
}

// Each topic's state as the completed review recorded it, keyed by topic key.
export function buildLoadedTopicStates(editTopics) {
    return editTopics.reduce((states, topic) => {
        return { ...states, [topic.key]: { ...topic.createInitialState(), ...topic.applyLoaded(topic.topicEntry) } };
    }, {});
}
